"use strict";

import $ from 'jquery';

$(() => {
    $('.advanced-search-toggle').on('click', (e) => {
        e.preventDefault();
        $(e.currentTarget).closest('.search-form').toggleClass('advanced-search-enabled');
    });
});
